export enum BarcodePrefixes {
	STUDENT = "YOKOG",
	ACADEMICIAN = "YOKAK",
}
